import classNames from "classnames";
import {ReactNode} from "react";

import {FormLabel, FormLabelTypography} from "@/components/form/FormLabel.tsx";

import styles from "./SwitchLabel.module.scss";

interface SwitchLabelProps {
  children?: ReactNode;
  className?: string;
  forId: string;
  helpText?: string;
  description?: string;
  disabled?: boolean;
  labelTypography?: FormLabelTypography;
  required?: boolean;
}

const SwitchLabel = ({children, className, forId, disabled, labelTypography, ...rest}: SwitchLabelProps) => {
  return (
    <div className={classNames(styles.switchLabelContainer, {[styles.disabled]: disabled}, className)}>
      <FormLabel forId={forId} className={styles.switchLabel} labelTypography={labelTypography} {...rest}>
        {children}
      </FormLabel>
    </div>
  );
};

SwitchLabel.displayName = "SwitchLabel";
export {SwitchLabel};
